<template>
	<div>
		<div v-if="!files.length && !showPreview">
			<div :class="['dropZone', dragging ? 'dropZone-over' : '']" @dragenter="dragging = true" @dragleave="dragging = false">
				<div class="dropZone-info">
					<span class="fa fa-cloud-upload dropZone-title"></span>
					<span class="dropZone-title">Перетащите сюда скриншоты для загрузки / {{ imageSrc }}</span>
					<div class="dropZone-upload-limit-info">
						<div>Максимальный размер: {{ size }} MB</div>
					</div>
				</div>
				<input type="file" @change="onChange" multiple>
			</div>
		</div>

		<div v-else class="dropZone-uploaded">
			<div class="dropZone-uploaded-info" v-show="showPreview">
				<div class="row">
					<div class="col image-container" v-if="imagePreview.length > 0" v-for="(image, index) in imagePreview" :key="index" >
						<viewer :images="image" :options="options">
						<img v-bind:src="image" style="height:270px; width:auto; object-fit:cover;">
						</viewer>
						<button type="button" class="btn btn-danger btn-sm remove-button" @click="removeFile(index)">x</button>
					</div>
				</div>
			</div>
<!--			<button type="button" class="btn btn-primary" @click="addMoreFiles" style="z-index: 9999">Добавить</button>-->
		</div>
	</div>
</template>

<script>
export default {
	props: ['imageSrc', 'size'],
	data() {
		return {
			files: [],
			showPreview: false,
			showExternal: false,
			imagePreview: [],
			dragging: false,
		};
	},
	methods: {
		loadImageArray(image) {
			this.showExternal = true;
			this.showPreview = 	true;
			this.imagePreview = image;
		},
		onChange(e) {
			const inputFiles = e.target.files;
			this.addFiles(inputFiles);
			e.target.value = '';
		},
		addFiles(inputFiles) {
			const newFiles = Array.from(inputFiles);
			this.files.push(...newFiles);
			this.createFiles(newFiles);
			this.dragging = false;
		},
		createFiles(newFiles) {
			newFiles.forEach(file => {
				if (/\.(jpe?g|png|gif)$/i.test(file.name)) {
					const reader = new FileReader();
					reader.addEventListener("load", () => {
						this.imagePreview.push(reader.result);
						this.showPreview = true;
					});
					reader.readAsDataURL(file);
				}
			});
			this.$emit('file', this.files);
		},
		removeFile(index) {
			if(this.files.length!=0){
				this.files.splice(index, 1);
			}
			if (this.showExternal){
				this.imagePreview.splice(index, 1);
			}
			this.files.splice(index, 1);
			this.showPreview = this.imagePreview.length > 0;
		//	this.$emit('file', this.files);
			this.$emit('screen', this.imagePreview);
		},
		removeFiles() {
			this.files = [];
			this.imagePreview = [];
			this.showPreview = false;
			this.dragging = false;
		},
		addMoreFiles() {
			console.log(1111);
			this.$refs.fileInput.click();
		},
	},
	computed: {
		extension() {
			return (this.files.length > 0) ? this.files[0].name.split('.').pop() : '';
		}
	}
};
</script>


<style>
.image-container {
	position: relative;
	margin-bottom: 15px;
}
.remove-button {
	position: absolute;
	top: 10px;
	right: 10px;
	z-index: 10;
}
.btn{
	text-align: right!important;
}
.dropZone {
	width: auto;
	height: auto;
	min-height: 300px;
	position: relative;
	border: 2px dashed #eee;
}

.dropZone:hover {
	border: 2px solid #2e94c4;
}

.dropZone:hover .dropZone-title {
	color: #1975A0;
}

.dropZone-info {
	color: #A8A8A8;
	position: absolute;
	top: 50%;
	width: 100%;
	transform: translate(0, -50%);
	text-align: center;
}

.dropZone-title {
	color: #787878;
}

.dropZone input {
	position: absolute;
	cursor: pointer;
	top: 0px;
	right: 0;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 100%;
	opacity: 0;
}

.dropZone-upload-limit-info {
	display: flex;
	justify-content: flex-start;
	flex-direction: column;
}

.dropZone-over {
	background: #5C5C5C;
	opacity: 0.8;
}

.dropZone-uploaded {
	width: auto;
	min-height: 300px;
	height: auto;
	position: relative;
	border: 2px dashed #eee;
}

.dropZone-uploaded-info {
	display: flex;
	flex-direction: column;
	align-items: center;
	color: #A8A8A8;
	position: absolute;
	top: 50%;
	width: 100%;
	transform: translate(0, -50%);
	text-align: center;
}

.removeFile {
	width: 200px;
}

</style>
